import React from 'react';
import _ from 'lodash';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import LayoutContainer from '../../components/LayoutContainer';
import Box from '../../components/Box';
import Button from '../../components/Button';
import MainContainer from '../../components/MainContainer';
import Logo from '../../components/Logo';
import DisplayIban from '../../components/DisplayIban';
import {destroySession} from '../../reducer';
import Title from '../../components/Title';
import useScrollToTop from '../../hooks/useScrollToTop';
import Teaser from '../../components/Teaser';
import {withTheme} from 'styled-components';
import DJSBSideBar from '../../components/DJSBSideBar';
import CollectingImage from '../../components/CollectingImage';

const InvalidFlow = ({formContext, dmBoxInfo, collectorInfo, history, startNewDonation, message, label, theme}) => {
  useScrollToTop();
  return <>
    <MainContainer
      backgroundImageUrl={theme?.donationBox?.imageAsBackground && formContext.isDonationBox && dmBoxInfo?.image?.publicUrl
        ? dmBoxInfo.image.publicUrl
        : formContext.backgroundImageUrl}
      backgroundImageTabletUrl={theme?.donationBox?.imageAsBackground && formContext.isDonationBox && dmBoxInfo?.image?.publicUrl
        ? dmBoxInfo.image.publicUrl
        : formContext.backgroundImageTabletUrl}
      backgroundImageMobileUrl={theme?.donationBox?.imageAsBackground && formContext.isDonationBox && dmBoxInfo?.image?.publicUrl
        ? dmBoxInfo.image.publicUrl
        : formContext.backgroundImageMobileUrl}
    />
    <LayoutContainer
      position={formContext.textPosition}
      header={<div>
        <div style={{float: 'left', display: 'inline-block'}}>
          <Logo url={formContext.websiteUrl} />
        </div>
        {formContext.isCollecting && theme?.collecting?.imageTopRight &&
          <div style={{float: 'right', display: 'inline-block'}}><CollectingImage collectorInfo={collectorInfo} /></div>}
        <DisplayIban iban='NL08 INGB 0000 0005 55' />
      </div>}
      content={<Box position={formContext.textPosition}
        hasTeaser={!_.isNil(formContext.pageTeaserHeader) || !_.isNil(formContext.pageTeaserBodyText) || !_.isEmpty(formContext.pageTeaserCarouselItems)}>
        <Title title={formContext.step1Header} />
        <div className='widgetContent invalidFlow'>
          <div>
            <p>{message ? message : 'Oeps, er ging iets mis. Je kan met onderstaande knop een nieuwe donatie starten.'}</p>
          </div>
          <Button label={label ? label : 'Start nieuwe donatie'} onClick={() => {
            startNewDonation(history);
          }} />
        </div>
      </Box>}
      sidebar={<>
        {theme?.djsb?.showDJSB && <DJSBSideBar formContext={formContext}/>}
        <Teaser header={formContext.pageTeaserHeader} body={formContext.pageTeaserBodyText} />
      </>}
      footer={formContext.footer}
      formContext={formContext}
    />
  </>;
};

const mapStateToProps = (state) => {
  return {
    formContext: state.reducer.formContext
  };
};

const mapDispatchToProps = (dispatch) => ({
  startNewDonation: (history) => {
    dispatch(destroySession(history));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withTheme(InvalidFlow)));
